import {TFilter, TList, TUUID} from '@/types';
import {TVerto, TTransaction, TIndividualCreateParams} from './types';
import {getVerto} from './mock';
import {getGroupList} from '../mock';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {apiRequestAdmin} from '../../../ws';
import faker from '@faker-js/faker';
import {GROUP_TYPE_VERTO} from '../constants';

import {
  ENDPOINT_ADMIN_PO_VERTO_GET,
  ENDPOINT_ADMIN_PO_VERTO_CANCEL,
  ENDPOINT_ADMIN_PO_VERTO_UPDATE,
  ENDPOINT_ADMIN_PO_VERTO_CREATE,
  ENDPOINT_ADMIN_PO_VERTO_LIST,
  ENDPOINT_ADMIN_BANKING_ACC
} from '../../../../constants/api';

// Возвращает информацию по конкретной выплате
export function apiAdminPayoutVertoGet(params: {payout_id: TUUID}): Promise<TVerto> {
  const url = ENDPOINT_ADMIN_PO_VERTO_GET;
  if (process.env.MOCK) {
    const response = getVerto(faker.finance.currencyCode());
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

// Возвращает информацию по конкретной выплате
export function apiAdminPayoutVertoDelete(params: {withdraw_id: TUUID}): Promise<TVerto> {
  const url = ENDPOINT_ADMIN_PO_VERTO_CANCEL;
  params = params || {};

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

// Возвращает информацию по конкретной выплате
export function apiAdminPayoutVertoUpdate(params: {withdraw_id: TUUID}): Promise<TVerto> {
  const url = ENDPOINT_ADMIN_PO_VERTO_UPDATE;
  params = params || {};

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

export function apiAdminBankingAccount(params: {account_id: TUUID, bank_id: TUUID}): Promise<TVerto> {
  const url = ENDPOINT_ADMIN_BANKING_ACC;
  params = params || {};

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

// Получение списка платежей Verto
const apiAdminPayoutVertoGroupList = (initiated: boolean, isTest) => (params) => {
  const url = ENDPOINT_ADMIN_PO_VERTO_LIST;
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;
  params.only_initiated = initiated;

  if (typeof isTest !== 'undefined') params.is_test = isTest


  if (process.env.MOCK) {
    const limit = faker.mersenne.rand(5);
    const response = {
      list: getGroupList([GROUP_TYPE_VERTO], limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
};

export const apiAdminPayoutVertoInitiatedList = apiAdminPayoutVertoGroupList(true, false);
export const apiAdminPayoutVertoInitiatedTestList = apiAdminPayoutVertoGroupList(true, true);
export const apiAdminPayoutVertoCompletedList = apiAdminPayoutVertoGroupList(false, undefined);


// Добавляет транзакцию Verto -> Merchant проведённую вне процессинга
export function apiAdminPayoutVertoManualUpdate(params: TTransaction): Promise<TVerto> {
  const url = ENDPOINT_ADMIN_PO_VERTO_UPDATE;
  if (process.env.MOCK) {
    const response = getVerto(faker.finance.currencyCode());
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

// Создаёт индивидуальную выплату на Verto для выбранного мерчанта
export function apiAdminPayoutVertoIndividualCreate(params: TIndividualCreateParams): Promise<TVerto> {
  const url = ENDPOINT_ADMIN_PO_VERTO_CREATE;
  if (process.env.MOCK) {
    const response = getVerto(faker.finance.currencyCode());
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

